export function resolveCreateIntentFeedback() {
  return {
    toastType: 'info',
    messageKey: 'court.paymentPending',
    fallback: 'Booking is awaiting payment confirmation',
  };
}
